import React, { FC, useContext, useEffect, useState } from 'react';

import { Grid, Hidden, Paper } from '@material-ui/core';

import { GlobalContext } from '../../../../store';
import { IEventRound } from '../../../../store/admin/eventRounds/store';
import { IAdminEvent } from '../../../../store/admin/events/store';

import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import Tooltip from '../../../../components/Tooltip';
import { Input } from '../../../../components/Input';
import { StyledContestSetup } from './ContestSetup.Styles';
import ContestSetupTable from './Components/ContestSelectorTable/ContestSetupTable';
import { ContestSelector } from './Components/ContestSelector';
import {
  ContestSetupProvider,
  useContestSetupDispatch,
  useContestSetupState
} from './Context/ContestSetup.context';
import { ContestSetupFilters } from './Components/ContestSetupFilters';
import { onForward } from './Utils/onForward';

export interface IProps {
  clubId: string;
  eventId: string;
  roundId: string;
}

const ContestSetup: FC<IProps> = props => {
  const { clubId, roundId, eventId } = props;

  const {
    actions: {
      adminRoundFormats: { get: getAdminRoundFormats },
      adminEventTeams: { get: getAdminEventTeams }
    },
    adminEvents,
    adminRoundFormats
  } = useContext(GlobalContext);

  const { playerLookupValue, selectedMetaFormat, leaderboards } = useContestSetupState();
  const {
    actions: { search, setContestSelectorOptions, setLeaderboards }
  } = useContestSetupDispatch();

  const [event, setEvent] = useState<IAdminEvent>();
  const [round, setRound] = useState<IEventRound>();

  useEffect(() => {
    getAdminRoundFormats(clubId, eventId, roundId, true);
  }, [clubId, eventId, roundId]);

  useEffect(() => {
    if (adminEvents && adminEvents[Number(eventId)]) {
      setEvent(adminEvents[Number(eventId)]);
    }
  }, [eventId, adminEvents]);

  useEffect(() => {
    if (event && !!event.rounds) {
      setRound(event.rounds.find(r => r.id === Number(roundId)));
    }
  }, [event, roundId]);

  useEffect(() => {
    setLeaderboards(Number(clubId), Number(eventId), Number(roundId));
  }, [clubId, eventId, roundId]);

  useEffect(() => {
    getAdminEventTeams(clubId, eventId);
  }, []);

  useEffect(() => {
    if (
      roundId &&
      adminRoundFormats &&
      adminRoundFormats[Number(roundId)] &&
      Object.values(leaderboards).length > 0
    ) {
      setContestSelectorOptions(adminRoundFormats[Number(roundId)]);
    }
  }, [adminRoundFormats, roundId, leaderboards]);

  return (
    <StyledContestSetup className="event-wizard-page form">
      <div className="full-width round-handicaps">
        <EventWizardStepTitle
          buttonOnClick={event ? onForward(clubId, event, roundId, round) : null}
          tooltip={
            <Tooltip
              classes={{ fab: 'tooltip-fab--shift-top-3' }}
              sectionKey="ROUND_HANDICAPS.TITLE"
            />
          }
          title="CONTEST SETUP"
        />

        <Paper elevation={1} className="paper add-players">
          <Grid className="grid-container" container={true} spacing={4}>
            <ContestSelector />

            <Grid className="grid-item right" item={true} xs={12} md={8}>
              {!!selectedMetaFormat && (
                <Hidden smDown={true}>
                  <div className="player-lookup-container">
                    <Input
                      fullWidth={true}
                      id="roster-lookup"
                      label="PLAYER LOOKUP"
                      onChange={search}
                      outlined={true}
                      placeholder="PLAYER LOOKUP"
                      type="search"
                      value={playerLookupValue}
                    />
                  </div>
                </Hidden>
              )}

              <ContestSetupFilters />

              <ContestSetupTable />
            </Grid>
          </Grid>
        </Paper>
      </div>
    </StyledContestSetup>
  );
};

export default (props: IProps) => (
  <ContestSetupProvider>
    <ContestSetup {...props} />
  </ContestSetupProvider>
);
